import * as client from '../../client'

// A function to fetch the current user session from stikis
export function fetchSession(dispatch) {
  return client.get('/user/session.json', dispatch)
}

// A function to create a new session (log in) on the server
export function createSession(data, dispatch) {
  return client.post('/user/sign_in.json', data, dispatch)
}
